import ShineMaterial from "../../rendering/star/shine-material";
import RenderManager from "../../rendering/render-manager";

const tmp = new THREE.Vector3();

class Shine extends THREE.Mesh {
    constructor({ star, temperature, map }) {
        const geometry = new THREE.RingBufferGeometry(4, 24, 64);
        const material = new ShineMaterial({ temperature, map });

        super(geometry, material);

        this.overridePicker = star;
        this.type = "Shine";
    }

    update(time) {
        this.material.uniforms.time.value = time;
        this.lookAt(tmp.setFromMatrixPosition(RenderManager.activeCamera.matrixWorld));
        this.position.set(0, 0, -5).applyQuaternion(this.quaternion);
    }
}

export default Shine;
export { Shine };